export const determinatePercentage = (value) => {
    const regex = /[%]/;
    return regex.test(value);
}